<template>
  <section class="app-main">
    <transition name="fade-transform" mode="out-in">
      <router-view :key="key"/>
    </transition>
  </section>
</template>

<script>
export default {
  name: "AppMain",
  computed: {
    key() {
      return this.$route.path;
    },
  },
};
</script>

<style lang="scss" scoped>
.app-main {
  margin-top: -10vh;
  height: 90vh;
  min-height: 700px;
  min-width: 1200px;
}
</style>



// WEBPACK FOOTER //
// src/user/layout/components/AppMain.vue